<template>
    <div>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="mkuList" :data="contractServcList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" :selectable="selectable" type="selection" width="55"></el-table-column>
                    <el-table-column prop="msu.title" label="显示名称" align="center"></el-table-column>
                    <el-table-column prop="msu.wrntPeriod" label="质保期" align="center"></el-table-column>
                    <el-table-column prop="msu.toDoorFee" label="上门费" align="center"></el-table-column>
                    <el-table-column prop="msu.workHourFee" label="工时费" align="center"></el-table-column>
                    <el-table-column prop="msu.generallFee" label="服务费" align="center"></el-table-column>
                    <el-table-column prop="msu.fixedSpec" label="固定规格说明" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="contractServcList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checKContractServcInfo!= null && checKContractServcInfo.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="msu.title" label="显示名称" align="center"></el-table-column>
                    <el-table-column prop="msu.wrntPeriod" label="质保期" align="center"></el-table-column>
                    <el-table-column prop="msu.toDoorFee" label="上门费" align="center"></el-table-column>
                    <el-table-column prop="msu.workHourFee" label="工时费" align="center"></el-table-column>
                    <el-table-column prop="msu.generallFee" label="服务费" align="center"></el-table-column>
                    <el-table-column prop="msu.fixedSpec" label="固定规格说明" align="center"></el-table-column>
                </el-table>
            </div>
            <!--<div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import contractApi from '../../api/contract'

    export default {
        name: 'swb-contract-servc-list-for-select',
        desc: '合同服务列表-选择',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            id: {
                type: Number,
            },
            contractServcIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                contractServcList: [],
                /*                pageNumber: 1,
                 totalCount: 1,
                 pageSize: 10,
                 pageSizes: [10, 20, 50, 100],*/
                selectContractServcList: [],
                checKContractServcInfo: null
            }
        },
        created: function () {
            let self = this;
            //
            self.getContractServcPageList();
        },
        methods: {
            /*handleSizeChange: function (val) {
             this.pageSize = val;
             this.handlePageChange(1);
             },
             handlePageChange: function (val) {
             let self = this;
             this.pageNumber = val;
             this.getContractServcPageList();
             },*/
            getContractServcPageList: function () {
                let self = this;
                let postData = {};
                /*let postData = {};
                 postData.pagination = {
                 pageSize: self.pageSize,
                 pageNumber: self.pageNumber,
                 };*/
                postData.id = self.id;
                postData.curValid = true;
                postData.closed = false;
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        let contractServcList = data.contractServcList;

                        //
                        self.contractServcList = contractServcList;
//                        self.totalCount = data.pagination.totalCount;
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let contractServcIds = this.contractServcIds;
                if(contractServcIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectContractServcList = val;
            },
            handleCurrentChange: function (val) {
                this.checKContractServcInfo = Utils.merge({}, val);
            },
            getContractServcInfo: function (contractServcInfo) {
                let contractServc = {};
                if(contractServcInfo != null) {
                    contractServc.id = contractServcInfo.id;
                    contractServc.title = contractServcInfo.msu.title;
                    contractServc.ssuId = contractServcInfo.msu.ssuId;
                    contractServc.toDoorFee = contractServcInfo.msu.toDoorFee;
                    contractServc.workHourFee = contractServcInfo.msu.workHourFee;
                    contractServc.generallFee = contractServcInfo.msu.generallFee;
                    contractServc.wrntPeriod = contractServcInfo.msu.wrntPeriod;
                    contractServc.fixedSpec = contractServcInfo.msu.fixedSpec;
                }
                return contractServc;
            },
            getContractServcList: function () {
                let contractServcList = [];
                let contractServcs = this.selectContractServcList;
                if(contractServcs != null && contractServcs.length > 0) {
                    for(var i = 0; i < contractServcs.length; i++) {
                        let mkuInfo = contractServcs[i];
                        let contractServcInfo = this.getContractServcInfo(mkuInfo);
                        contractServcList.push(contractServcInfo);
                    }
                }
                return contractServcList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let contractServcList = self.selectContractServcList;
                    if(contractServcList != null && contractServcList.length > 0) {
                        result.type = "info";
                        result.data = self.getContractServcList();
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个服务！';
                    }
                } else {
                    let contractServc = self.checKContractServcInfo;
                    if(contractServc != null) {
                        result.type = "info";
                        result.data = self.getContractServcInfo(contractServc);
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个服务！';
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/contract/ContractServcListForSelect.vue